import { makeStyles } from '../../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    remainingItems: {
        padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
        marginRight: 2,
        fontSize: 12,
        color: theme.colors.gray[900],
        backgroundColor: theme.colors.gray[0],
        border: `1px solid ${theme.colors.gray[200]}`,
        borderRadius: theme.shape.borderRadius,
    },
}));
//# sourceMappingURL=ValueContainerWithMultiValuesSliced.styles.js.map